var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c("br"),
      _c("br"),
      _c("br"),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }),
        _vm._v(" "),
        _c("div", { staticClass: "col", attrs: { id: "imprimir" } }, [
          _c("div", { staticClass: "col" }, [
            _c("strong", [_vm._v(_vm._s(_vm.tienda))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _vm._v(
              "\n          FECHA: " +
                _vm._s(_vm.date[2]) +
                "/" +
                _vm._s(_vm.date[1]) +
                "/" +
                _vm._s(_vm.date[0]) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _vm._v("VENDEDOR: " + _vm._s(_vm.seller.name))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _vm._v("CLIENTE: " + _vm._s(_vm.sale.nameReference))
          ]),
          _vm._v(" "),
          _c("table", { staticClass: "table table-responsive" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.sales, function(stock) {
                return _c("tr", { key: stock.id }, [
                  _c("td", { domProps: { textContent: _vm._s(stock.amount) } }),
                  _vm._v(" "),
                  _c("td", {
                    domProps: { textContent: _vm._s(stock.nameProduct) }
                  }),
                  _vm._v(" "),
                  _c("td", { domProps: { textContent: _vm._s(stock.price) } }),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(stock.price * stock.amount))])
                ])
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c("strong", [_vm._v("TOTAL: ")]),
            _vm._v(_vm._s(_vm.sale.total))
          ]),
          _vm._v(" "),
          _vm._m(1)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.top-center",
                    value: "Imprimir recibo",
                    expression: "'Imprimir recibo'",
                    modifiers: { "top-center": true }
                  }
                ],
                staticClass: "btn btn-primary",
                on: {
                  click: function($event) {
                    return _vm.imprimirRecibo()
                  }
                }
              },
              [_c("i", { staticClass: "icon-fa icon-fa-print" })]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip.top-center",
                    value: "Regresar",
                    expression: "'Regresar'",
                    modifiers: { "top-center": true }
                  }
                ],
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/venta/lista" }
              },
              [_c("i", { staticClass: "icon-fa icon-fa-arrow-left" })]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col" })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Cant.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Descripción")]),
        _vm._v(" "),
        _c("th", [_vm._v("Precio")]),
        _vm._v(" "),
        _c("th", [_vm._v("Subt.")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("strong", [_vm._v("ESTE DOCUMENTO NO ES UNA FACTURA")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c3ed7c1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c3ed7c1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/pdf/Print.vue
// module id = 626
// module chunks = 0